
<div *ngIf="cageVM">
  <h4>
    Precios de Visceras ({{cageVM.CageInfo}})
  </h4>

  <hr />


        <div class="d-flex justify-content-between align-items-center mb-5"
        style="max-width:600px;">
          <label for="generalPrice">Precio General:</label>
        <input type="number" id="generalPrice"
               class="form-control" style="max-width: 200px;"
               [(ngModel)]="generalPrice"
               placeholder="Precio General" />
        <button class="btn btn-secondary"
                (click)="setGeneralPrice()">
          Guardar precio general
        </button>
        </div>

  <div class="row" id="inputsRow" *ngIf="guts">
    <div class="col-md-2 col-sm-6 my-2 d-flex align-items-center gap-2"
         *ngFor="let gut of guts">
<label [for]="gut.Id" class="small mb-0">
      {{ gut.Id }}:
    </label>
      <input type="number"
                 class="form-control form-control-sm"
                 [(ngModel)]="gut.Price"
                  [id]="gut.Id"
                 (focusout)="setPrice(gut)"
                  appFocusNext
                 placeholder="Precio {{gut.Id}}" />
    </div>
  </div>

  <hr />

  <div class="text-right">
    <button id="saveButton"
    class="btn btn-primary"
            type="button"
            (click)="close()">
      Cerrar
    </button>

</div>
